import { useCallback } from "react";

import { usePreferences } from "@/core/state/preferences";

import { formatDateTime } from "./formatDateTime";

export function useFormatDateTime() {
  const locale = usePreferences((state) => state.locale);
  const timezone = usePreferences((state) => state.timezone);
  return useCallback(
    (value: unknown, fallback = "") =>
      formatDateTime(value, locale, timezone, fallback),
    [locale, timezone],
  );
}
